// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2920":"41f9eabe7004066bf5ee","3436":"5abaa97713d1d0c8fc16","6752":"27fb92ca335be99991bf","9945":"c324fd64895cf3457999"}[chunkId] + ".css";
};